import { nftSchema } from '@0xtorch/core'
import { z } from 'zod'
import type { LowerHex } from './hex'
import { addressPrimitiveSchema, bigintTextSchema } from './primitive'

export const erc721TransferSchema = z.object({
  address: addressPrimitiveSchema,
  from: addressPrimitiveSchema,
  logIndex: z.number().int(),
  to: addressPrimitiveSchema,
  tokenId: bigintTextSchema,
})

export type Erc721Transfer = z.infer<typeof erc721TransferSchema>

export const erc721TokenTransferSchema = erc721TransferSchema.extend({
  token: nftSchema,
})

export type Erc721TokenTransfer = z.infer<typeof erc721TokenTransferSchema>

export type Erc721NftId = `evm_721_${number}_${LowerHex}_${bigint}`

export const isErc721NftId = (id: string): id is Erc721NftId =>
  /^evm_721_\d+_0x[0-9a-f]{40}_\d+$/.test(id)
